// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
  var headerHeight = $("header").innerHeight() || 0; // ヘッダー追従の場合 // if header following

  // リンクが同一ページ（同一パス + 同一クエリ）のときだけスムーススクロールする
  function isSamePage(linkEl) {
    try {
      var url = new URL(linkEl.href, window.location.href);
      var current = new URL(window.location.href);
      var normalizePath = function (p) {
        return (p || "").replace(/\/+$/, "");
      };
      return normalizePath(url.pathname) === normalizePath(current.pathname) && (url.search || "") === (current.search || "");
    } catch (e) {
      // URL API が使えない/想定外の場合はフォールバック
      return linkEl.pathname === location.pathname && (linkEl.search || "") === (location.search || "");
    }
  }

  $(document).on("click", 'a[href*="#"]', function (e) {
    var hash = (this.hash || "").trim(); // '#system' 形式のみ扱う
    if (!hash || hash === "#") return;

    // 同じページのアンカーだけ補正してスクロールする
    if (!isSamePage(this)) return; // 別ページならデフォルト即時遷移に任せる

    var decoded = decodeURIComponent(hash.replace(/^#/, ""));
    var targetEl = document.getElementById(decoded);
    if (!targetEl) return;
    e.preventDefault();
    var position = $(targetEl).offset().top - headerHeight;
    if (!Number.isFinite(position)) return;
    position = Math.max(0, position);
    $("html, body").stop().animate({ scrollTop: position }, 550, "swing");
  });
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

jQuery(function ($) {
  //二重送信抑制
  let submitBtn = $("input[type='submit'].wpcf7-submit");
  submitBtn.click(function () {
    $(this).css("pointer-events", "none");
    $(this).css("opacity", "0.5");
  });
  // 入力項目にエラーがあったらボタン復活
  document.addEventListener(
    "wpcf7invalid",
    function () {
      submitBtn.css("pointer-events", "auto");
      submitBtn.css("opacity", "1");
    },
    false,
  );
});

// p-front__function スライダー（768px以下のみ）
jQuery(function ($) {
  if (typeof Swiper === "undefined") return;
  if (!$(".p-front__function__slider").length) return;

  let functionSwiper = null;

  function setupFunctionSlider() {
    if (window.innerWidth <= 768) {
      if (!functionSwiper) {
        functionSwiper = new Swiper(".p-front__function__slider", {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: ".p-front__function__pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".p-front__function__next",
            prevEl: ".p-front__function__prev",
          },
        });
      }
    } else if (functionSwiper) {
      functionSwiper.destroy(true, true);
      functionSwiper = null;
    }
  }

  setupFunctionSlider();
  $(window).on("resize", setupFunctionSlider);
});

// 768px以下でスクロール時にヘッダーに .fixed を付与
jQuery(function ($) {
  var $header = $("header");
  if (!$header.length) return;

  function toggleFixed() {
    if (window.innerWidth <= 768 && 568 < window.innerWidth && $(window).scrollTop() > 0) {
      $header.addClass("fixed");
    } else {
      $header.removeClass("fixed");
    }
  }

  $(window).on("scroll resize", toggleFixed);
  toggleFixed();
});

// 目次
jQuery(document).ready(function ($) {
  const tocLinks = $("#ez-toc-container .ez-toc-link");
  if (!tocLinks.length) return;

  const headingMap = [];

  tocLinks.each(function () {
    const href = $(this).attr("href");
    const hash = decodeURIComponent(href.split("#")[1]);
    const linkText = $(this).text().trim();

    const headingEl = $("h1,h2,h3,h4,h5,h6")
      .filter(function () {
        return $(this).text().trim() === linkText;
      })
      .first();

    if (headingEl.length) {
      headingEl.attr("id", hash);
      headingMap.push({ heading: headingEl, link: $(this) });
    }
  });

  if (!headingMap.length) return;

  function updateCurrent() {
    const scrollTop = $(window).scrollTop();
    const offset = 100;
    let current = null;

    headingMap.forEach(function (item) {
      if (item.heading.offset().top - offset <= scrollTop) {
        current = item.link;
      }
    });

    tocLinks.removeClass("is-current");
    if (current) {
      current.addClass("is-current");
    } else {
      headingMap[0].link.addClass("is-current");
    }
  }

  $(window).on("scroll", updateCurrent);
  updateCurrent();
});

window.addEventListener("load", function () {
  const scrollArea = document.querySelector(".js-priceComparison__tableWrap");

  if (!scrollArea) return;

  if (window.innerWidth <= 568) {
    scrollArea.scrollLeft = (scrollArea.scrollWidth - scrollArea.clientWidth) * 0.5;
  }
});
